import { vocab } from '@/ds';

export const eventStatusLabel = (status: 'live' | 'cancelled'): string =>
  vocab.STATUS.event?.[status]?.label ?? status;
